// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// function LoginPage() {
//   const [formData, setFormData] = useState({
//     enrollmentNumber: "",
//     password: "",
//   });

//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);

//     try {
//       const response = await fetch("http://localhost:5002/api/auth/login", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         credentials: "include", // ✅ Ensures cookies are sent
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();
//       if (!response.ok) throw new Error(data.error || "Login failed");

//       // ✅ Store JWT Token & Role in localStorage
//       localStorage.setItem("token", data.token);
//       localStorage.setItem("role", data.user.role); 

//       alert("✅ Login Successful!");

//       // ✅ Redirect user based on role
//       if (data.user.role === "alumni") {
//         navigate("/profile/alumni");
//       } else if (data.user.role === "student") {
//         navigate("/profile/student");
//       }
//     } catch (error) {
//       console.error("❌ Login Error:", error);
//       setError(error.message);
//     }
//   };

//   return (
//     <div className="registration">
//       <form onSubmit={handleSubmit} className="form-container">
//         <h1 className="form-heading">Login</h1>

//         {error && <p className="error-message">{error}</p>}

//         <div className="form-group">
//           <label htmlFor="enrollmentNumber">Enrollment Number:</label>
//           <input
//             type="text"
//             id="enrollmentNumber"
//             name="enrollmentNumber"
//             value={formData.enrollmentNumber}
//             onChange={handleChange}
//             placeholder="Enter enrollment number"
//             required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="password">Password:</label>
//           <input
//             type="password"
//             id="password"
//             name="password"
//             value={formData.password}
//             onChange={handleChange}
//             placeholder="Enter your password"
//             required
//           />
//         </div>

//         <button type="submit" className="submit-button">
//           Login
//         </button>

//         <p className="toggle-link">
//           Don't have an account? <span className="highlighted-link">Register</span>
//         </p>
//       </form>
//     </div>
//   );
// }

// export default LoginPage;




import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';

function LoginPage() {
  const [formData, setFormData] = useState({
    enrollmentNumber: "",
    password: "",
  });

  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
  
    try {
      const response = await fetch("https://rbac-auth-service.onrender.com/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", // ✅ Ensures cookies are sent
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Login failed");
  
      // ✅ Debugging (Check what backend is returning)
      console.log("🔎 Backend Response:", data);
  
      // ✅ Store JWT Token, Role, and User ID in localStorage
      localStorage.setItem("token", data.token);
      localStorage.setItem("role", data.user?.role || data.role);
      localStorage.setItem("userId", data.user?._id || "");  // 🔥 FIXED: Storing `userId`
      localStorage.setItem("userDetails", JSON.stringify(data.user));
      // ✅ Debugging (Verify values in storage)
      console.log("🔎 Stored userId:", localStorage.getItem("userId"));
      console.log("🔎 Stored Role:", localStorage.getItem("role"));
      console.log("🔎 Stored Token:", localStorage.getItem("token"));
  
      alert("✅ Login Successful!");
  
      // ✅ Redirect user based on role
      if (data.user?.role === "alumni" || data.role === "alumni") {
        navigate("/profile/alumni");
      } else if (data.user?.role === "student" || data.role === "student") {
        navigate("/profile/student");
      } else {
        navigate("/");
      }
    } catch (error) {
      console.error("❌ Login Error:", error);
      setError(error.message);
    }
  };

  return (
    <div className="registration">
      <form onSubmit={handleSubmit} className="form-container">
        <h1 className="form-heading">Login</h1>

        {error && <p className="error-message">{error}</p>}

        <div className="form-group">
          <label htmlFor="enrollmentNumber">Enrollment Number:</label>
          <input
            type="text"
            id="enrollmentNumber"
            name="enrollmentNumber"
            value={formData.enrollmentNumber}
            onChange={handleChange}
            placeholder="Enter enrollment number"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter your password"
            required
          />
        </div>

        <button type="submit" className="submit-button">
          Login
        </button>

        {/* <p className="toggle-link">
          Don't have an account? <span className="highlighted-link">Register</span>
        </p> */}

<p>
  Don't have an account? <Link to="/pages/registration" className="highlighted-link">Register</Link>
</p>
      </form>
    </div>
  );
}

export default LoginPage;
